import AnimatedPercentagePot from './AnimatedPercentagePot';
export default AnimatedPercentagePot;
